import NavBar from "./components/NavBar";
import Cubes from "./components/Cubes";
import ContactPage from "./pages/ContactPage";
import ToDoApp from "./ToDoApp/ToDoApp";
import BudgetApp from "./BudgetApp/BudgetApp";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Route, Routes } from "react-router-dom";

export default function App() {
  return (
    <>
      <NavBar />
      <div className="container pt-5">
        <div className="row">
          <Routes>
            <Route exact path="/" element={<Cubes />} />
            <Route exact path="/ContactPage" element={<ContactPage />} />
            <Route exact path="/ToDoApp/ToDoApp" element={<ToDoApp />} />
            <Route exact path="/BudgetApp/BudgetApp" element={<BudgetApp />} />
            <Route
              exact
              path="https://saltirewebsites.com/ReactShoppingCart/App"
              element={<App />}
            />
          </Routes>
        </div>
      </div>
    </>
  );
}
